import { Component, HostListener, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { UpdateService } from '../../../services/update.service';

@Component({
  selector: 'app-pwa-prompt',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  template: `
    <div *ngIf="showPrompt" class="pwa-prompt">
      <button mat-raised-button color="primary" (click)="installPwa()">
        Install App
      </button>
    </div>
    <div *ngIf="showUpdateButton" class="update-prompt">
      <button mat-raised-button color="accent" (click)="checkForUpdates()">
        Check for Updates
      </button>
    </div>
  `,
  styles: [`
    .pwa-prompt, .update-prompt {
      position: fixed;
      bottom: 20px;
      left: 50%;
      transform: translateX(-50%);
      z-index: 1000;
      padding: 16px;
      border-radius: 8px;
      background: white;
      box-shadow: 0 2px 5px rgba(0,0,0,0.2);
    }
    .update-prompt {
      bottom: 80px;
    }
  `]
})
export class PwaPromptComponent implements OnInit {
  private deferredPrompt: any;
  showPrompt = false;
  showUpdateButton = false; // Don't show by default, check in ngOnInit

  constructor(
    private snackBar: MatSnackBar,
    private updateService: UpdateService
  ) {}

  ngOnInit() {
    // Only show update button if service worker is enabled
    this.showUpdateButton = this.updateService.isEnabled();
  }

  @HostListener('window:beforeinstallprompt', ['$event'])
  onBeforeInstallPrompt(e: Event) {
    e.preventDefault();
    this.deferredPrompt = e;
    this.showPrompt = true;
  }

  async installPwa() {
    if (this.deferredPrompt) {
      this.deferredPrompt.prompt();
      const { outcome } = await this.deferredPrompt.userChoice;
      if (outcome === 'accepted') {
        this.snackBar.open('App installed successfully!', 'Close', { duration: 3000 });
      }
      this.deferredPrompt = null;
      this.showPrompt = false;
    }
  }

  checkForUpdates() {
    this.updateService.checkForUpdate()
      .then(hasUpdate => {
        if (hasUpdate) {
          this.snackBar.open('Update available! The app will reload shortly.', 'Close', { duration: 3000 });
        } else {
          this.snackBar.open('No updates available. You have the latest version.', 'Close', { duration: 3000 });
        }
      })
      .catch(err => {
        console.error('Error checking for updates:', err);
        this.snackBar.open('Error checking for updates. Please try again later.', 'Close', { duration: 3000 });
      });
  }
}